import { useState } from 'react';

import PageMeta from './PageMeta';
import {
  RedesignFooter,
  RedesignHeader,
  RedesignPage,
  SiteLink,
} from './RedesignShell';

const companyRequisites = [
  ['Наименование компании:', 'ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ ФАТАЛИЕВ ГИЯС ХАЗАР ОГЛЫ'],
  ['ИНН:', '771819238234'],
  ['ОГРНИП:', '322774600295323'],
  ['Юридический адрес:', '107014, РОССИЯ, Г МОСКВА, УЛ ЖЕБРУНОВА, Д 2, КВ 9'],
  ['Фактический адрес:', '107014, РОССИЯ, Г МОСКВА, УЛ ЖЕБРУНОВА, Д 2, КВ 9'],
];

const bankRequisites = [
  ['Банк:', 'АО «Тинькофф Банк»'],
  ['Расчетный счет:', '40802810800003263445'],
  ['Корреспондентский счет:', '30101810145250000974'],
  ['БИК:', '044525974'],
];

function SectionHeader({ title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <h2>{title}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function RequisitesTable({ rows }) {
  const [copied, setCopied] = useState('');

  const copyValue = async (label, value) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(label);
    } catch {
      setCopied('');
    }
  };

  return (
    <div className="price-list">
      {rows.map(([label, value]) => (
        <div className="price-row price-row-three" key={`${label}-${value}`}>
          <span>{label}</span>
          <b>{value}</b>
          <button
            type="button"
            className="link-flat"
            aria-label={`Скопировать ${label}`}
            title={`Скопировать ${label}`}
            onClick={() => copyValue(label, value)}
          >
            ⧉
          </button>
        </div>
      ))}
      {copied && <p className="section-note">Скопировано: {copied}</p>}
    </div>
  );
}

function RequisitesPage() {
  return (
    <RedesignPage>
      <PageMeta
        title="Реквизиты компании — данные организации и карточка партнера"
        description="Реквизиты компании: ИНН, ОГРН, банковские данные. Скачать карточку партнера и получить информацию для оплаты и договоров"
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container service-hero-grid">
          <div>
            <h1>Реквизиты компании</h1>
            <p className="hero-sub">На этой странице представлены официальные реквизиты компании для заключения договоров, выставления счетов и проведения оплат.</p>
            <p className="service-hero-copy">Вы можете использовать данные ниже для работы с нашей компанией, а также скачать карточку партнера в удобном формате.</p>
          </div>
          <div className="service-hero-panel" aria-label="Реквизиты компании">
            {companyRequisites.slice(0, 3).map(([label, value], index) => (
              <div className="panel-line" key={label}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <b>{label} {value}</b>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader title="Основные реквизиты компании" description="Здесь размещены актуальные данные организации." />
          <div className="pricing-layout">
            <RequisitesTable rows={companyRequisites} />
            <div className="price-note">
              <h2 className="standalone-h2">Скачать карточку партнера</h2>
              <p>Для удобства вы можете скачать карточку партнера со всеми реквизитами компании.</p>
              <a href="/requisites-card.pdf" className="btn btn-primary" target="_blank" rel="noreferrer">
                Скачать карточку партнера
              </a>
              <p>Карточка содержит полные данные организации и подходит для бухгалтерии, договоров и оплаты.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader title="Банковские реквизиты" description="Данные для оплаты счетов и безналичных расчетов." />
          <RequisitesTable rows={bankRequisites} />
        </div>
      </section>

      <section className="ink sec-pad" id="requisites-contacts">
        <div className="container">
          <SectionHeader dark title="Контакты для связи" description="Если у вас возникли вопросы по реквизитам или оплате, свяжитесь с нами:" />
          <div className="compact-card-grid">
            <div className="compact-card">
              <p>Телефон: <SiteLink href="tel:+79256530454" className="link-flat">+7 (925) 653-04-54</SiteLink></p>
              <p>Email: <SiteLink href="mailto:fatality.digitalstudio@gmail.com" className="link-flat">fatality.digitalstudio@gmail.com</SiteLink></p>
              <p>Наши специалисты быстро ответят и помогут с любыми вопросами.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader title="Дополнительная информация" />
          <div className="split-proof">
            <p>Мы работаем с юридическими и физическими лицами по всей России.</p>
            <p>Предоставляем закрывающие документы, работаем по договору и обеспечиваем прозрачные условия сотрудничества.</p>
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default RequisitesPage;
